import { render, staticRenderFns } from "./SupplierMgmt.vue?vue&type=template&id=6a745fdc"
import script from "./SupplierMgmt.vue?vue&type=script&lang=js"
export * from "./SupplierMgmt.vue?vue&type=script&lang=js"
import style0 from "./SupplierMgmt.vue?vue&type=style&index=0&id=6a745fdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports